import React from 'react'
import { Box, Modal, Typography } from '@mui/material'
import { ModalExpenses } from './ModalExpenses/ModalExpenses';
import { ModalStatus } from './ModalStatus/ModalStatus';
import { ModalAdvance } from './ModalAdvance/ModalAdvance';


const style = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start', // Cambiar de center a flex-start
    position: 'fixed', // Cambiar de absolute a fixed
    top: '5vh', // En lugar de 50% con transform
    left: '50%',
    transform: 'translateX(-50%)', // Solo centrar horizontalmente
    width: '70%',
    maxWidth: '1200px', // Agregar un ancho máximo
    color: 'black',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    height: '90vh',
    maxHeight: '90vh', // Asegurar que no exceda la altura de la ventana
    overflow: 'auto'
};

export const ModalModule = ({ useFetchInit }) => {
    const { dataModal, toggle } = useFetchInit
    const { open, titleModal, componentModal, dataRequest } = dataModal
    const { message1, message2, message3 } = dataRequest || {}

    // Estilo condicional para componentes largos
    const isLongComponent = componentModal === 'advance-section'
    
    const dynamicStyle = {
        ...style,
        ...(isLongComponent && {
            top: '5vh',
            transform: 'translateX(-50%)',
            justifyContent: 'flex-start'
        })
    }

    return (
        <>
            <Modal
                open={open}
                onClose={toggle}
                className='modal-body'
                disableEscapeKeyDown={true}
                size='xl'
            >
                <Box sx={dynamicStyle}>
                    <Typography variant="h6" component="h2" sx={{ mb: 2 }}>
                        {titleModal}
                        <p>{message1} {message2} {message3}</p>
                    </Typography>

                    <Box sx={{ flex: 1, overflow: 'auto' }}>
                        {componentModal === 'expenses-section' && (
                            <ModalExpenses useFetchInit={useFetchInit} dataModal={dataModal} />
                        )}
                        {componentModal === 'status-section' && (
                            <ModalStatus useFetchInit={useFetchInit} dataModal={dataModal} />
                        )}
                        {componentModal === 'advance-section' && (
                            <ModalAdvance useFetchInit={useFetchInit} dataModal={dataModal} />
                        )}
                    </Box>
                </Box>
            </Modal>
        </>
    )
}